module.exports = __webpack_public_path__ + "static/media/keyword-research.6492ff98.svg";